import { render } from "./ReviewsSection.vue?vue&type=template&id=05fa8fb4&scoped=true"
import script from "./ReviewsSection.vue?vue&type=script&lang=js"
export * from "./ReviewsSection.vue?vue&type=script&lang=js"

import "./ReviewsSection.vue?vue&type=style&index=0&id=05fa8fb4&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05fa8fb4"]])

export default __exports__